function EstimatePage(){
    return (
        <>
            <h1>Estimate Page</h1>
        </>
    )
}

export default EstimatePage;